import { breakpointMatches } from 'app/functions';
import { optionsSelector } from 'app/store/selectors';
import { useAppSelector } from './appHooks';

export const useMobileView = () => {
  const options = useAppSelector(optionsSelector);

  if (options.mobileView) {
    return true;
  }

  return breakpointMatches('small').matches;
};
